export default __webpack_public_path__ + "sentry-nudge-bg.png";